"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSetSize = exports.isCompact = exports.isThin = void 0;

var isThin = function isThin(string) {
  return string === 'thin';
};

exports.isThin = isThin;

var isCompact = function isCompact(string) {
  return string === 'compact';
};

exports.isCompact = isCompact;

var isSetSize = function isSetSize(string) {
  return isThin(string) || isCompact(string);
};

exports.isSetSize = isSetSize;